<template>
  <ValidationObserver ref="answerOptions">
    <div class="mb-10">
      <p class="font-weight-bold">Answer Options</p>
      <AnswerOption
        v-for="(option, index) in allOptions"
        @remove="allOptions.splice(index, 1)"
        :option="option"
        :key="index"
        ref="answerOptionsForm"
      />
      <div
        v-if="showValidationErrors && !size(allOptions)"
        class="text-error my-5"
      >
        This field is required
      </div>
      <PrimaryButton text @click.native="addOption">
        Add Option +
      </PrimaryButton>
    </div>
  </ValidationObserver>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import AnswerOption from "./AnswerOption";
import { size, map } from "lodash";

export default {
  components: {
    ValidationObserver,
    PrimaryButton,
    AnswerOption
  },
  props: {
    options: {
      type: Array,
      default: () => []
    }
  },
  created() {
    this.allOptions = [...this.options];
  },
  data() {
    return {
      allOptions: [],
      showValidationErrors: false
    };
  },
  methods: {
    addOption() {
      this.allOptions = [
        ...this.allOptions,
        {
          option: "",
          validResponse: false
        }
      ];
    },
    async validate() {
      this.showValidationErrors = true;
      const fieldsValidationStatus = await Promise.all(
        map(this.$refs.answerOptionsForm, optionForm =>
          optionForm.validateForm()
        )
      );
      return (
        size(this.allOptions) && size(fieldsValidationStatus.filter(Boolean))
      );
    },
    size
  }
};
</script>

<style lang="scss"></style>
